import { render } from "./PlaceholderDropdown.vue?vue&type=template&id=b6b2c09a&ts=true"
import script from "./PlaceholderDropdown.vue?vue&type=script&lang=ts"
export * from "./PlaceholderDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__